module.exports = __webpack_public_path__ + "ptc_nakagawa_G2.1625f0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_G2.jpg
// module id = NLBw
// module chunks = 0